export const authResolverErrorFallThroughValue = 'fallThrough';
